export default "__VITE_ASSET__DVe_nkZM__"